// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Card: {
    select: 'Vybrat',
    titleLinkTooltip: 'Přejít na stránku',
    collapseCardTooltip: 'Sbalit kartu',
    expandCardTooltip: 'Rozbalit kartu'
  },
  CardList: {
    loadMore: 'Načíst další',
    notFound: 'Nebyly nalezeny žádné položky.',
    toolbarSelect: 'Vybrat',
    viewCards: 'Karty',
    viewTiles: 'Dlaždice',
    viewList: 'Seznam',
    toolbarView: 'Zobrazení'
  },
  ClosingConfirmation: {
    confirm: 'Opustit',
    cancel: 'Zpět',
    content: 'Určitě chcete toto okno zavřít? Pokud jste provedli jakékoliv změny, neuloží se.'
  },
  Cuttable: {
    showMore: 'Zobrazit více',
    showLess: 'Zobrazit méně'
  },
  Dialog: {
    cancelButton: 'Zrušit'
  },
  DrawerProgress: {
    cancelButton: 'Zrušit'
  },
  Dropdown: {
    close: 'Zavřít'
  },
  Form: {
    submitButton: 'Uložit',
    applyButton: 'Použít',
    cancelButton: 'Zrušit'
  },
  FormField: {
    clear: 'Vymazat',
    remove: 'Odebrat',
    addMore: 'Přidat další'
  },
  FormFieldPassword: {
    improvePassword: 'Jak vylepšit heslo:',
    passwordTooShort: 'Použijte delší heslo.',
    lettersLowerCase: 'Použijte alespoň jedno malé písmeno.',
    lettersUpperCase: 'Použijte alespoň jedno velké písmeno.',
    numbers1: 'Použijte alespoň jedno číslo.',
    numbers3: 'Použijte alespoň tři čísla.',
    specialChar1: 'Použijte alespoň jeden speciální znak (například: !, @, #, $, %, ^, &, *, ?, _, ~).',
    specialChar2: 'Použijte alespoň dva speciální znaky (například: !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: 'Použijte velká i malá písmena.',
    comboLettersAndNumbers: 'Použijte kombinaci čísel a písmen.',
    comboLettersNumbersSpecial: 'Použijte kombinaci čísel, písmen a speciálních znaků.',
    yourPasswordIsStrong: 'Sílu hesla ještě vylepšíte tím, že použijete delší heslo.',
    passwordStrength: 'Síla hesla: %%strength%%.',
    strengthVeryStrong: 'VELMI SILNÉ',
    strengthStrong: 'SILNÉ',
    strengthVeryWeak: 'VELMI SLABÉ',
    strengthWeak: 'SLABÉ',
    strengthMedium: 'STŘEDNÍ',
    hidePassword: 'Skrýt heslo',
    showPassword: 'Ukázat heslo',
    generateButton: 'Vygenerovat',
    copyButtonHint: 'Kopírovat heslo',
    copySuccessToast: 'Heslo zkopírováno',
    generateButtonHint: 'Vygenerovat silné heslo'
  },
  InPlaceEdit: {
    editButtonHint: 'Upravit hodnotu',
    okButtonHint: 'Uložit změny',
    cancelButtonHint: 'Zahodit změny'
  },
  InputFile: {
    browseButton: 'Vybrat soubor...'
  },
  List: {
    totalRows: 'Celkem položek: %%totalRows%%',
    selectedRows: 'Vybráno položek: %%selectedRows%% z %%totalRows%%',
    all: 'všechny',
    allItemsOnPageSelected: 'Vybrány všechny položky na stránce',
    allItemsSelected: 'Vybrány všechny položky',
    selectAllItems: 'Vybrat všechny položky',
    selectAllItemsOnPage: 'Vybrat všechny položky na stránce',
    deselectAll: 'Zrušit výběr'
  },
  ListEmptyView: {
    filteredTitle: 'Nepodařilo se najít žádné položky odpovídající filtru',
    emptyTitle: 'Zdá se, že tady nic není',
    filteredDescription: 'Upřesněte dotaz nebo odstraňte část kritérií z filtru a zkuste to znovu.'
  },
  ListOperation: {
    cancelButton: 'Zrušit'
  },
  Pagination: {
    totalShort: 'z %%total%%',
    itemsPerPage: 'Položek na stránku',
    all: 'Všechny',
    total: 'Stránka %%current%% z %%total%%'
  },
  ProgressDialog: {
    closeButton: 'Zavřít',
    cancelButton: 'Zrušit'
  },
  Select: {
    noOptions: 'Žádné možnosti',
    placeholder: 'Vybrat...'
  },
  SpotPopup: {
    total: '%%current%% z %%total%%'
  },
  Toaster: {
    closeGroup: 'Zavřít skupinu'
  }
};